/**
 * User-friendly error messages for API errors.
 *
 * This file centralizes all user-facing error messages to:
 * - Keep UI components clean and focused on presentation
 * - Make it easy to update messaging across the app
 * - Support future internationalization (i18n)
 * - Maintain consistency in tone and messaging
 */

export const ERROR_MESSAGES = {
  // Generic fallback errors
  GENERIC: 'An error occurred. Please try again.',
  NETWORK_ERROR: 'Unable to connect. Please check your internet connection.',
  SERVER_ERROR: 'Something went wrong on our end. Please try again later.',

  // Lounge Access errors
  LOUNGE_ACCESS: {
    NO_SESSION_FOUND:
      "We couldn't find a matching session. Please verify that the masseuse, locker number, and customer name are correct.",
    INVALID_LOCKER: 'Please enter a valid locker number.',
    INVALID_MASSEUSE: 'Please select a valid masseuse.',
    INVALID_CUSTOMER: 'Please enter a valid customer name.',
  },

  // Survey errors
  SURVEY: {
    SUBMISSION_FAILED: 'Failed to submit your survey. Please try again.',
    ALREADY_SUBMITTED: 'This survey has already been submitted.',
  },

  // Authentication errors
  AUTH: {
    INVALID_CREDENTIALS: 'Invalid username or password.',
    SESSION_EXPIRED: 'Your session has expired. Please log in again.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
  },
} as const;

// Type for the error messages object
export type ErrorMessages = typeof ERROR_MESSAGES;
